import script from "./AgentActions.vue?vue&type=script&lang=ts&setup=true"
export * from "./AgentActions.vue?vue&type=script&lang=ts&setup=true"

import "./AgentActions.vue?vue&type=style&index=0&id=8c2724ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c2724ee"]])

export default __exports__